import React, { useState } from "react";
import Modal from "components/global/modal";
import Button from "components/button/button";
import CustomCheckbox from "components/checkbox/custom-checkbox";
import { useTranslation } from "react-i18next";

export default function AdultContentWarning({ hide, ...props }) {
    const {t} = useTranslation();
    const title = props.title || "Adult Content Warning";
    const [understand, setUnderstand] = useState(false);
    const [dontShowAgain, setDontShowAgain] = useState(false);

    const onSave = () => {
        if (!understand) return; // require explicit acknowledgement
        if(dontShowAgain){
            localStorage.setItem("dontShowAdultContentWarning", "true");
        }
        hide({ acknowledged: true, dontShowAgain });
    };

    const Footer = () => (
        <div className="relative grid gap-y-3 1sm:gap-y-0 1sm:flex 1sm:flex-row 1sm:items-center 1sm:justify-end 1sm:space-x-2">
            <Button
                buttonName="Cancel"
                buttonClass="bg-thBg py-4 px-8"
                buttonTextClass="text-black text-sm font-semibold"
                onClick={() => hide()}
            />
            <Button
                key="save-adult-warning"
                buttonName="Save"
                buttonClass={`bg-primary py-4 px-10 ${!understand ? "opacity-50 cursor-not-allowed" : ""}`}
                buttonTextClass="text-white text-sm font-semibold"
                onClick={() => onSave()}
            />
        </div>
    );

    return (
        <Modal
            footer={<Footer />}
            width="w-18/20 md:w-15/20 2md:w-11/20 3md:w-10/20 4md:w-9/20 1xl:w-7/20"
            contentClassName="rounded-lg overflow-auto custom-scroll"
            wrapperClassName="overflow-visible"
            footerClass="border-t border-gray"
        >
            <div className="w-full">
                <div className="w-full">
                    <div className="pl-10 pr-7 pt-3.5 flex justify-between items-center">
                        <div className="w-full">
                            <p className="text-base 2sm:text-3xl text-lightBlack font-bold tracking-tighter">
                                {`⚠️ ${t('YouHaveMark')}`}
                            </p>
                        </div>

                        <span className="close" onClick={() => hide()}></span>
                    </div>

                    <div className="px-10 w-full border-b-2 border-gray">
                        {/* empty - no tabs here, keep styling consistent */}
                    </div>
                </div>

                <div className="mx-8.5 my-6 text-sm text-lightBlack">
                    <p>{t('thisMeansYour')}:</p>
                    <ul className="list-disc list-inside mt-2 mb-3">
                        <li>🔒 {t('areLoggedIn')}</li>
                        <li>🔞 {t("haveShowadult")}</li>
                    </ul>

                    <p className="font-semibold mt-2">{t('beforeSaving')}:</p>
                    <ul className="list-disc list-inside mt-2 mb-3">
                        <li>{t('doesThisMilestone')}</li>
                        <li>{t('ifItOnly')}</li>
                    </ul>

                    <p className="mt-2">{t('UsingTheAdult')}</p>
                    <p className="mt-1">{t('youCanChange')}</p>

                    <hr className="my-4" />

                    <div className="flex flex-col space-y-3">
                        <CustomCheckbox
                            name="adult-understand"
                            checked={understand}
                            onChange={(e) => setUnderstand(e?.target?.checked)}
                            label={t('iUnderstand')}
                            labelClass="text-sm"
                            containerStyle={""}
                            isBoxType={true}
                        />

                        <CustomCheckbox
                            name="adult-dont-show"
                            checked={dontShowAgain}
                            onChange={(e) => setDontShowAgain(e?.target?.checked)}
                            label={t("optionalDon'tShow")}
                            labelClass="text-sm"
                            containerStyle={""}
                            isBoxType={true}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
}
